import orderUser from '@@/store/orderUser'
import orderRegion from '@@/store/orderRegion'
import defaultValueConfig from '@@/store/defaultValueConfig'
import orderEngineer from './orderEngineer'
import smtOffiaccount from './smtOffiaccount'

const orderComponentModules = {
  orderUser,
  orderRegion,
  defaultValueConfig,
  orderEngineer,
  smtOffiaccount
}

export default orderComponentModules